import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { translate, InjectedTranslateProps } from "react-i18next";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import FormatListBulleted from "@material-ui/icons/FormatListBulleted";
import { setAllAreasToggle } from "../../actions/store/overview-actions";
import IconButton from "@material-ui/core/IconButton";

export interface AreaToggleProps {}

interface State {}

interface ConnectedAreaToggleProps extends WithStyles<typeof styles> {
	showAlleAreasToggle: boolean;
	layout: "desktop" | "tablet" | "phone";
	setAllAreasToggle: (status: boolean) => void;
}

type Props = AreaToggleProps &
	ConnectedAreaToggleProps &
	InjectedTranslateProps;

export class AreaToggle extends React.Component<Props, State> {
	public state: State = {};

	handleAreaToggleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		const { showAlleAreasToggle } = this.props;
		this.props.setAllAreasToggle(!showAlleAreasToggle);
	};

	public render() {
		const { classes, showAlleAreasToggle, layout } = this.props;

		return (
			<React.Fragment>
					{layout === "phone" ? (
						<IconButton
							color="inherit"
							className={classNames(classes.toggleButtonPhone, {
								[classes.toggleActive]: showAlleAreasToggle
							})}
							onClick={this.handleAreaToggleClick}
						>
							<FormatListBulleted />
						</IconButton>
					) : (
						<Button
							className={classNames(classes.toggleButton, {
								[classes.toggleActive]: showAlleAreasToggle
							})}
							variant="outlined"
							color="inherit"
							onClick={this.handleAreaToggleClick}
						>
							<FormatListBulleted className={classes.iconSmall} />
								<span className={classes.iconButtonLabel}>
									Alle Innen
								</span>
						</Button>
					)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	showAlleAreasToggle: state.overviewAllAreasToggle,
	layout: state.layout
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setAllAreasToggle: (status: boolean) => dispatch(setAllAreasToggle(status))
});

const styles = (theme: Theme) =>
	createStyles({
		iconSmall: {
			fontSize: 20
		},
		iconButtonLabel: {
			textTransform: "none",
			paddingLeft: 6,
			paddingRight: 6
		},
		toggleButton: {
			paddingLeft: 8,
			paddingRight: 8,
			borderColor: "rgba(255, 255, 255, 0.3)"
		},
		toggleButtonPhone: {
		},
		toggleActive: {
			"&, &:hover": {
				background: "#c2984b",
			},
		}
	});

export const ConnectedAreaToggle = translate("translations")(
	withStyles(styles)(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(AreaToggle)
	)
);
